import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from './components/ui/sonner';

// Components
import Header from './components/Header';
import Footer from './components/Footer';

// Pages
import LandingPage from './pages/LandingPage';
import ProgramsPage from './pages/ProgramsPage';
import ProgramDetailPage from './pages/ProgramDetailPage';
import ProgramPricingPage from './pages/ProgramPricingPage';
import BookingPage from './pages/BookingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentCancelPage from './pages/PaymentCancelPage';
import PreQualificationPage from './pages/PreQualificationPage';
import AdminPage from './pages/AdminPage';
import CPFPage from './pages/CPFPage';
import AboutPage from './pages/AboutPage';
import LegalPage from './pages/LegalPage';
import FaqPage from './pages/FaqPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import ReglementPage from './pages/ReglementPage';
import VeilleProPage from './pages/VeilleProPage';
import Livret1ASPPage from './pages/Livret1ASPPage';
import OralVAEPage from './pages/OralVAEPage';
import BookingConfirmPage from './pages/BookingConfirmPage';

function App() {
  const [user, setUser] = useState(null);

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
    if (userData.token) {
      localStorage.setItem('token', userData.token);
    }
    if (userData.role === 'admin' && userData.token) {
      localStorage.setItem('adminToken', userData.token);
    }
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };

  // Check if user is logged in from localStorage on mount
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header user={user} onLogout={handleLogout} />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/programs" element={<ProgramsPage />} />
          <Route path="/programs/:id" element={<ProgramDetailPage />} />
          <Route path="/programs/:id/pricing" element={<ProgramPricingPage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/booking/confirm/:bookingId" element={<BookingConfirmPage action="confirm" />} />
          <Route path="/booking/cancel/:bookingId" element={<BookingConfirmPage action="cancel" />} />
          <Route path="/pre-qualification" element={<PreQualificationPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/cpf" element={<CPFPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/legal" element={<LegalPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/reglement" element={<ReglementPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/veille-professionnelle" element={<VeilleProPage />} />
          <Route path="/livret-1-asp" element={<Livret1ASPPage />} />
          <Route path="/oral-vae" element={<OralVAEPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/payment/cancel" element={<PaymentCancelPage />} />
          <Route 
            path="/login" 
            element={user ? <Navigate to={user.role === 'admin' ? '/admin' : '/dashboard'} /> : <LoginPage onLogin={handleLogin} />} 
          />
          <Route 
            path="/register" 
            element={user ? <Navigate to={user.role === 'admin' ? '/admin' : '/dashboard'} /> : <RegisterPage onLogin={handleLogin} />} 
          />
          <Route 
            path="/dashboard" 
            element={user ? <DashboardPage /> : <Navigate to="/login" />} 
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
